import { render, staticRenderFns } from "./ObjectFileItem.vue?vue&type=template&id=70710ee2&scoped=true&"
import script from "./ObjectFileItem.vue?vue&type=script&lang=js&"
export * from "./ObjectFileItem.vue?vue&type=script&lang=js&"
import style0 from "./ObjectFileItem.vue?vue&type=style&index=0&id=70710ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70710ee2",
  null
  
)

export default component.exports